/**
 * §1 ANALYTICS · first-touch attribution capture, app-wide.
 *
 * Capture used to happen on `/create` alone, so a visitor arriving on the
 * marketing landing page with `?utm_source=…` and then walking into the funnel
 * looked identical to organic traffic. This mounts once inside the router and
 * captures on FIRST touch of ANY route. `saveAttribution` is first-touch-wins,
 * so a later `/create?utm_…` cannot overwrite the original campaign.
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  captureAttributionFromLocation,
  saveAttribution,
} from "@/lib/consumer-session";
import { LAUNCH_PROGRAM_SLUG } from "@/services/programs";

const AttributionBoot = () => {
  const location = useLocation();

  useEffect(() => {
    saveAttribution(
      LAUNCH_PROGRAM_SLUG,
      captureAttributionFromLocation(location.search || window.location.search),
    );
    // First touch only — deliberately not keyed on location.
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};

export default AttributionBoot;
